// Get URL Parameter and set a local storage key

// Get URL Parameter
const urlParams = new URLSearchParams(window.location.search)
const vanity = urlParams.get('vanity')

// Set a local storage key
function setLocalStorageKey(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (error) {
      // Handle the error here
      console.error('Error setting local storage key:', error);
    }
}


// Set a local storage key
if (vanity) setLocalStorageKey('vanity', vanity);
